import { useRejectCurrentReturnRequestHasNothingToHandle } from "@/pages/(app)/returns/refund/hooks/use-reject-line-items-list-section";
import { useCurrentReturnRequest } from "@/pages/(app)/returns/utils/current-return-request-context";
import { FileWarning } from "lucide-react";
import useTranslation from "@babackapp/translations/use-translation";

export function useRejectItemsAction(onClick: () => void) {
  const t = useTranslation();
  const returnRequest = useCurrentReturnRequest();
  const approvedAlready = returnRequest.status.approved.done;
  const nothingToReject = useRejectCurrentReturnRequestHasNothingToHandle();
  const isReturnRequestInError = returnRequest.status.error.done;
  const isCancelled = returnRequest.status.cancelled.done;

  return {
    label: t("returnDetail.rejected"),
    icon: <FileWarning className="h-5 w-5 text-orange-400" />,
    description: "Rejeter un ou plusieurs items",
    enabled:
      approvedAlready && !nothingToReject && !isReturnRequestInError && !isCancelled,
    onClick,
  };
}
